import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import AddIcon from '@mui/icons-material/Add';
import Fab from '@mui/material/Fab';
import Grid from '@mui/material/Grid2';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import BorderColorIcon from '@mui/icons-material/BorderColor';


import CameraAltIcon from '@mui/icons-material/CameraAlt';


import axios from "axios";
import Swal from 'sweetalert2';

import { Container, TextField } from '@mui/material';

const StyledFab = styled(Fab)({
    position: 'absolute',
    zIndex: 1,
    top: -30,
    left: 0,
    right: 0,
    margin: '0 auto',
});

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
  });

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function ModalEditarProyecto(params) {
    axios.defaults.withCredentials = true;

    const base = {
        "nombre": "",
        "ubicacion": ""
    }


    const [articulo, setArticulo] = React.useState({
        "nombre": '',
        "ubicacion": ''
    });

    React.useEffect(() => {
            let tempArticulo = { ...articulo };
            tempArticulo.id = params.ultimoProyecto.id;
            tempArticulo.nombre = params.ultimoProyecto.nombre
            tempArticulo.ubicacion = params.ultimoProyecto.ubicacion
            setArticulo(tempArticulo);
    }, [params.ultimoProyecto]);

    const [open, setOpen] = React.useState(false);    

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleCancelar = () => {
        handleClose();
        setArticulo(base);
    }

    const handleChangeData = (e) => {
        let tempArticulo = { ...articulo };
        switch (e.target.name) {
            case "proyecto":
                tempArticulo.nombre = e.target.value;
                break;
            case "ubicacion":
                tempArticulo.ubicacion = e.target.value;
                break;
            default:
                break;
        }
        setArticulo(tempArticulo);
    }

    const handleSaveArticulo = () => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: "Vas a editar tu proyecto.",
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Editar',
        }).then((result) => {
            if (result.isConfirmed) {
                // El usuario hizo clic en "Sí"
                guardarArticulo();
            } else {
                // El usuario hizo clic en "No"
                Swal.fire({
                    title: 'Accion Cancelada',
                    icon: 'error',
                    text: "",
                    showConfirmButton: false,
                    timer: 1000
                });
            }
        });
    }

    const guardarArticulo = async () => {
        try {
            const response = await axios.post(
                "https://apimedidas.ahouseinterior.com/editar_proyecto.php",
                articulo,
                { headers: { "Content-Type": "application/json" } }
            );

            // Verifica y almacena los datos recibidos
            if (response.data && response.data.status === "success") {

                // Aquí podrías almacenar el ID del artículo guardado si es necesario                

                // Subir la imagen solo si el artículo se guardó correctamente

                handleClose();
                setArticulo(base)
                Swal.fire({
                    title: 'Proyecto Editado',
                    text: 'El proyecto fue editado con exito.',
                    icon: 'success',
                    timer: 1000,
                    showConfirmButton: false,
                });
                params.fetchUltimoProyecto()                


            } else {
                Swal.fire({
                    title: 'Error',
                    text: 'No se pudo guardar el proyecto.',
                    icon: 'error'
                });
            }
        } catch (err) {
            Swal.fire({
                title: 'Error',
                text: 'Ocurrió un error al conectar con el servidor.',
                icon: 'error'
            });
        }
    };


    return (
        <React.Fragment>
            <IconButton color={params.color} aria-label="add" onClick={handleClickOpen}>
                <BorderColorIcon />
            </IconButton>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    Editar Proyecto
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <Grid container spacing={2} rowSpacing={2} columns={10}>
                        <Grid xs={5}>                            
                            <TextField
                                fullWidth
                                name='proyecto'
                                label='Proyecto'
                                variant='outlined'
                                value={articulo.nombre}
                                onChange={handleChangeData}
                            />
                        </Grid>
                        <Grid xs={10}>
                            <TextField
                                fullWidth
                                name='ubicacion'
                                label='Ubicacion'
                                variant='outlined'                                
                                value={articulo.ubicacion}
                                onChange={handleChangeData}
                            />
                        </Grid>                                            
                    </Grid>
                </DialogContent>
                <DialogActions style={{display:"flex", justifyContent:"space-between"}}>
                    <Button variant='outlined' color="error" onClick={handleCancelar}>
                        Cancelar
                    </Button>
                    <Button variant='contained' onClick={handleSaveArticulo}>
                        Guardar
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment>
    )
}

export default ModalEditarProyecto;
